var _circle, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadApp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23.3741,
    cy: 23.2842,
    r: 22.5225,
    fill: "url(#paint0_linear_148_255)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.75 26.0827L38.625 19.6243L36.7 17.816L33.125 21.1743V11.8743H30.375V21.1743L26.8 17.816L24.875 19.6243L31.75 26.0827ZM33.125 28.666V35.1243C33.125 36.5452 31.8875 37.7077 30.375 37.7077H16.625C15.1125 37.7077 13.875 36.5452 13.875 35.1243V11.8743C13.875 10.4535 15.1125 9.29102 16.625 9.29102H26.25V14.4577H16.625V32.541H30.375V28.666H33.125Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_148_255",
    x1: 23.3741,
    y1: 0.761719,
    x2: 23.3741,
    y2: 45.8068,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B426D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7419FB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadApp);
export default __webpack_public_path__ + "static/media/download-app.c87d8145b132b6b897627b267d507d28.svg";
export { ForwardRef as ReactComponent };